"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importDefault(require("react"));
var ConfigProvider_1 = require("../../ConfigProvider");
function ToasterContainer(_a) {
    var children = _a.children, className = _a.className, style = _a.style;
    var prefix = ConfigProvider_1.usePrefix('toaster-container');
    return react_1.default.createElement("div", { className: classnames_1.default(prefix, className), style: style }, children);
}
exports.default = ToasterContainer;
//# sourceMappingURL=index.js.map